var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlackLogoWhiteBg = function SvgBlackLogoWhiteBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 420 167"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "black_logo-white_bg_svg__a",
    d: "M.003.357h63.96v72.937H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "black_logo-white_bg_svg__c",
    d: "M0 167h418.53V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 93.706)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "black_logo-white_bg_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#black_logo-white_bg_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#060809",
    d: "M27.446 58.91c-5.177 0-7.756-2.543-7.756-6.746 0-7.774 8.703-10.437 24.586-12.116 0 10.4-7.032 18.861-16.83 18.861M34.293.357C22.947.357 9.883 5.71 2.795 11.361L9.271 24.99c5.688-5.205 14.882-9.65 23.176-9.65 7.877 0 12.228 2.636 12.228 7.933 0 3.582-2.885 5.381-8.34 6.087C15.979 32.013.003 37.626.003 53.324c0 12.442 8.86 19.975 22.703 19.975 9.871 0 18.666-5.492 22.85-12.738v10.706h18.408V26.41C63.964 7.881 51.086.357 34.294.357",
    mask: "url(#black_logo-white_bg_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#060809",
    d: "M219.145 96.087v68.888h19.706v-33.187c0-15.781 9.547-20.411 16.208-20.411 2.598 0 6.105.751 8.424 2.486l3.59-18.212c-3.042-1.299-6.225-1.586-8.832-1.586-10.131 0-16.496 4.49-20.698 13.6V96.088h-18.398ZM358.415 94.066c-10.419 0-18.203 6.16-22.257 12.099-3.767-7.673-11.746-12.099-21.292-12.099-10.42 0-17.628 5.79-20.959 12.442V96.089h-18.992v68.888h19.716v-35.46c0-12.739 6.661-18.834 12.887-18.834 5.631 0 10.808 3.646 10.808 13.045v41.249h19.688v-35.46c0-12.878 6.513-18.834 13.026-18.834 5.204 0 10.697 3.785 10.697 12.905v41.389h19.687v-47.614c0-15.485-10.419-23.297-23.009-23.297M171.184 96.087h-17.85v-7.005c0-9.11 5.205-11.717 9.695-11.717 4.954 0 8.814 2.198 8.814 2.198l6.077-13.888s-6.16-4.027-17.359-4.027c-12.59 0-26.915 7.098-26.915 29.373v5.066h-29.883v-7.005c0-9.11 5.204-11.717 9.686-11.717 2.551 0 5.984.593 8.823 2.198l6.077-13.888c-3.628-2.134-9.454-4.027-17.359-4.027-12.59 0-26.915 7.098-26.915 29.373v5.066h-11.43v15.197h11.43v53.69h19.688v-53.69h29.883v53.69h19.688v-53.69h17.85V96.087Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "black_logo-white_bg_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#black_logo-white_bg_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#060809",
    d: "M182.94 164.977h19.668V96.09H182.94z",
    mask: "url(#black_logo-white_bg_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FA0EA",
    d: "M297.689.003c-53.18 0-100.58 36.916-114.034 84.381h19.28c11.235-35.348 49.376-66.373 94.754-66.373 55.156 0 102.825 41.991 102.825 107.362 0 14.678-1.902 27.908-5.501 39.598h18.704l.185-.64c3.062-12.061 4.62-25.162 4.62-38.958C418.522 52.47 365.398.003 297.69.003",
    mask: "url(#black_logo-white_bg_svg__d)"
  }))));
};
export default SvgBlackLogoWhiteBg;